export default __webpack_public_path__ + "static/media/conduitEditCover.cd8c728d.jpg";